/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
export type NoteEntityTypeEnum = "contacts" | "containers" | "shipments" | "vessels" | "voyages" | "%future added value";
export type ExternalNotesQueryVariables = {
    entityType: NoteEntityTypeEnum;
    entitySlug: string;
};
export type ExternalNotesQueryResponse = {
    readonly externalNoteList: ReadonlyArray<{
        readonly slug: string;
        readonly content: string;
        readonly addedAt: string;
        readonly isSticky: boolean;
        readonly role: string;
        readonly addedBy: {
            readonly username: string;
        };
    }>;
};
export type ExternalNotesQuery = {
    readonly response: ExternalNotesQueryResponse;
    readonly variables: ExternalNotesQueryVariables;
};



/*
query ExternalNotesQuery(
  $entityType: NoteEntityTypeEnum!
  $entitySlug: String!
) {
  externalNoteList(entityType: $entityType, entitySlug: $entitySlug) {
    slug
    content
    addedAt
    isSticky
    role
    addedBy {
      username
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "entitySlug"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "entityType"
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "entitySlug",
        "variableName": "entitySlug"
      },
      {
        "kind": "Variable",
        "name": "entityType",
        "variableName": "entityType"
      }
    ],
    "concreteType": "Note",
    "kind": "LinkedField",
    "name": "externalNoteList",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "slug",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "content",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "addedAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isSticky",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "role",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "addedBy",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "username",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "ExternalNotesQuery",
    "selections": (v2/*: any*/),
    "type": "ApplicationQuery",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "ExternalNotesQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "3b1a6a355ec0f19af59d63a38a3c43ad",
    "id": null,
    "metadata": {},
    "name": "ExternalNotesQuery",
    "operationKind": "query",
    "text": "query ExternalNotesQuery(\n  $entityType: NoteEntityTypeEnum!\n  $entitySlug: String!\n) {\n  externalNoteList(entityType: $entityType, entitySlug: $entitySlug) {\n    slug\n    content\n    addedAt\n    isSticky\n    role\n    addedBy {\n      username\n    }\n  }\n}\n"
  }
};
})();
(node as any).hash = 'ddec90534abf8ac4d2e5da71fc43c5e0';
export default node;
